import { mergeIconColorVars as e } from "../icon-props.js";
import { jsx as t } from "react/jsx-runtime";
//#region src/icons/play.tsx
function n({ colors: n, style: r, ...i }) {
	return /* @__PURE__ */ t("svg", {
		viewBox: "0 0 24 24",
		fill: "none",
		"aria-hidden": "true",
		focusable: "false",
		xmlns: "http://www.w3.org/2000/svg",
		style: {
			...e(n),
			...r
		},
		...i,
		children: /* @__PURE__ */ t("path", {
			d: "M6.04883 1.87109C6.43321 1.88872 6.76347 2.04073 7.0127 2.17578C7.30644 2.33497 7.65456 2.56788 8.042 2.82617L18.5576 9.83691C18.8754 10.0488 19.1713 10.2442 19.3965 10.4258C19.6233 10.6087 19.891 10.8624 20.0449 11.2334C20.2483 11.7238 20.2482 12.2752 20.0449 12.7656C19.891 13.1367 19.6233 13.3913 19.3965 13.5742C19.1713 13.7558 18.8754 13.9513 18.5576 14.1631L8.042 21.1738C7.65461 21.4321 7.30641 21.665 7.0127 21.8242C6.72787 21.9786 6.33708 22.1551 5.88087 22.1279C5.29715 22.0931 4.75809 21.8042 4.40528 21.3379C4.12946 20.9733 4.05887 20.5502 4.0293 20.2275C3.99883 19.8949 4.00001 19.4763 4.00001 19.0107V4.98926C4.00001 4.52375 3.99884 4.10512 4.0293 3.77246C4.05886 3.44982 4.1295 3.02671 4.40528 2.66211C4.75809 2.19573 5.29711 1.90692 5.88087 1.87207L6.04883 1.87109ZM6.00001 19.0107C6.00001 19.5158 6.00137 19.8253 6.02149 20.0449C6.02268 20.0578 6.02515 20.0698 6.02637 20.0811C6.03653 20.0758 6.04895 20.0717 6.06055 20.0654C6.25446 19.9603 6.51261 19.7898 6.93262 19.5098L17.4482 12.499C17.798 12.2658 18.0029 12.1277 18.1406 12.0166C18.1477 12.0109 18.1531 12.0041 18.1592 11.999C18.1533 11.9942 18.1473 11.9878 18.1406 11.9824C18.0029 11.8714 17.7977 11.7339 17.4482 11.501L6.93262 4.49023C6.51232 4.21003 6.25451 4.03873 6.06055 3.93359C6.04868 3.92716 6.03673 3.92236 6.02637 3.91699C6.02508 3.92869 6.02274 3.94149 6.02149 3.95508C6.00139 4.17477 6.00001 4.4842 6.00001 4.98926V19.0107Z",
			fill: "var(--icon-color-primary, currentColor)"
		})
	});
}
//#endregion
export { n as PlayIcon };
